(function(){

    let article_toc_block = document.querySelector('.article-toc');

    article_toc_block.querySelector('.title').addEventListener('click',function(){
      article_toc_block.classList.toggle('active');
    })

    const setTocScrollMargin = () => {
      const nav = document.getElementById('SiteHeader');
      const height = nav?.offsetHeight || 0;

      const toc_bar_height = document.querySelector('.article-toc-wrapper')?.offsetHeight || 0;
      document.documentElement.style.setProperty('--toc-scroll-margin', `${height}px`);
      document.documentElement.style.setProperty('--toc-bar-height', `${toc_bar_height}px`);
    };
    setTocScrollMargin();
    window.addEventListener('resize', setTocScrollMargin);
    document.addEventListener('DOMContentLoaded', setTocScrollMargin);


    let arrow_down_html = article_toc_block.querySelector('.chevron-icon').outerHTML;


    let toc_structure = {};
    let toc_parent_id = 0;
    document.querySelector('.article__wrapper').querySelectorAll('h2, h3').forEach((item, index, arr)=>{
      
      if(item.closest('.article-cta__content')){
        return;
      }

      let text = item.textContent.trim().replace(/[:.]$/, '');
 
      if(!text){
        return false;
      }


      let item_id = item.id;
      if(!item_id){
        item_id = `toc_${index}`;
        item.id = item_id;
      };

      if(item.tagName == "H2" || toc_parent_id === 0){
        toc_structure[index] = {
          name: text,
          subitems:[]
        }
        toc_parent_id = index;
      }
      else{
        toc_structure[toc_parent_id].subitems.push([text, index])
      }
    })


    let result_string = "";
    Object.entries(toc_structure).forEach(([key, value]) => {


      if(value.subitems.length){
        let text = value.name.split(' ');
        let last_word = text.pop();
        result_string+=`<li><a href="#toc_${key}">${text.join(' ')} <span class='last-word'>${last_word}${arrow_down_html}</span></a>`
      }
      else{
         result_string+=`<li><a href="#toc_${key}">${value.name}</a>`
      }


      if(value.subitems.length){
        result_string+=`<div class="dropdown-wrapper"><ul class="dropdown">`;
        value.subitems.forEach(subitem=>{
          result_string+=`<li><a href="#toc_${subitem[1]}">${subitem[0]}</a></li>`
        })
        result_string+="</ul></div>"
      }
      result_string+="</li>"
    });


    let toc_main_list = document.querySelector('.toc-main-list');
    toc_main_list.insertAdjacentHTML('beforeend', result_string);

    toc_main_list.querySelectorAll('.chevron-icon').forEach(item=>{
      item.addEventListener('click',(e)=>{
        e.stopPropagation();
        e.preventDefault();
        let li = e.target.closest('li');
        li.classList.toggle('active');
        li.closest('ul').querySelectorAll('li').forEach(item=>{
          if(item != li){
            item.classList.remove('active');
          }
        })
      })
    });


    toc_main_list.querySelectorAll('a').forEach(item=>{
      item.addEventListener('click',(e)=>{
        article_toc_block.classList.add('is-closing');
        article_toc_block.classList.remove('active');
        requestAnimationFrame(()=>article_toc_block.classList.remove('is-closing'));
      })
    })


    const tocWrapper = document.querySelector('.toc-main-list-wrapper');
    tocWrapper.addEventListener('transitionstart', () => {
      tocWrapper.classList.add('is-transition')
    });
    tocWrapper.addEventListener('transitionend', () => {
      tocWrapper.classList.remove('is-transition')
    });
  
})();